import IcArrowRightSlim from 'assets/Icons/Arrow/IcArrowRightSlim';
import IconArrowRight from 'assets/Icons/Arrow/Icon_arrow_right';
import IcCalendarPointColorBlue from 'assets/Icons/Calendar/IcCalendarPointColorBlue';
import IcCalendarPointColorLightGray from 'assets/Icons/Calendar/IcCalendarPointColorLightGray';
import IcCalendarPointColorPurple from 'assets/Icons/Calendar/IcCalendarPointColorPurple';
import IcCalendarRed from 'assets/Icons/Calendar/IcCalendarRed';
import GenderMan from 'assets/Icons/Gender/GenderMan';
import GenderWoman from 'assets/Icons/Gender/GenderWoman';
import ProcessCheckBar from 'components/Hospital/ProcessCheckBar';
import { mindupAdminMobilePaths } from 'constants/path';
import { IDDiagnosis, IDDiagnosisNull } from 'models/DCK/basicInterface';
import { ReservationType } from 'models/MindUpAdmin/MindupAdminUserReservationConsultationPageTypes';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Accent, BackgroundColor, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { Radius } from 'styles/Global/objectStyles';
import { Body3Medium, Body3Regular, Body3SemiBold, Body4Medium, Body5Regular, Body5SemiBold } from 'styles/Global/typography';
import { calculateAge } from 'utils/calculateAge';
import { formatDateTime, splitDateTime } from 'utils/calculateTime';
import { changeMobileForm } from 'utils/changeMobileForm';

interface CounselingCardsProps {
    diagnosisInfo?: IDDiagnosis;
    processCheckBarClick?: (item: IDDiagnosisNull) => void;
    onClick?: (counselData: ReservationType) => void;
}

export const SurveyEnd = ({ diagnosisInfo }: CounselingCardsProps) => {
    const { birthDate } = calculateAge(diagnosisInfo?.patientIdentityNumber || '');

    return (
        <Layout>
            <TitleWrapper $color={TextColor.color_text_weak} $backgroundColor={BackgroundColor.color_background_light}>
                <IcCalendarPointColorLightGray />
                요청된 상담 일시가 없습니다.
            </TitleWrapper>
            <InfoContainer>
                <FlexWrapper>
                    <InfoTitle>대상자</InfoTitle>
                    <Name>{diagnosisInfo?.patientName}</Name>
                    {diagnosisInfo?.patientGender === 'male' ? <GenderMan $width='16px' $height='16px' /> : <GenderWoman $height='16px' $width='16px' />}
                    <BirthWrapper>({birthDate})</BirthWrapper>
                </FlexWrapper>
                <FlexWrapper>
                    <InfoTitle>연락처</InfoTitle>
                    <Body3Regular>{changeMobileForm(diagnosisInfo?.patientMobile!)}</Body3Regular>
                </FlexWrapper>
            </InfoContainer>
        </Layout>
    );
};

export const Standby = ({ diagnosisInfo, processCheckBarClick }: CounselingCardsProps) => {
    const navigate = useNavigate();

    const { birthDate } = calculateAge(diagnosisInfo?.patientIdentityNumber || '');

    return (
        <Layout onClick={() => navigate(mindupAdminMobilePaths.mindUpAdminMobileDetailDiagnosis, { state: diagnosisInfo })}>
            <TitleWrapper $color={TextColor.color_text_normal} $backgroundColor={BackgroundColor.color_background_primary_neutral} style={{ justifyContent: 'space-between' }}>
                <DateWrapper>
                    <IcCalendarPointColorBlue />
                    {formatDateTime(diagnosisInfo?.diagnosisDateTime!)}
                    <Body3Medium style={{ color: TextColor.color_text_light, marginLeft: '-4px' }}>상담</Body3Medium>
                </DateWrapper>
                <ArrowWrapper>
                    <IcArrowRightSlim />
                </ArrowWrapper>
            </TitleWrapper>
            <InfoContainer>
                <FlexWrapper>
                    <InfoTitle>대상자</InfoTitle>
                    <Name>{diagnosisInfo?.patientName}</Name>
                    {diagnosisInfo?.patientGender === 'male' ? <GenderMan $width='16px' $height='16px' /> : <GenderWoman $height='16px' $width='16px' />}
                    <BirthWrapper>({birthDate})</BirthWrapper>
                </FlexWrapper>
                <FlexWrapper>
                    <InfoTitle>연락처</InfoTitle>
                    <Body3Regular>{changeMobileForm(diagnosisInfo?.patientMobile!)}</Body3Regular>
                </FlexWrapper>
            </InfoContainer>
            <ProcessCheckBarWrapper>
                <ProcessCheckBar diagnosisInfo={diagnosisInfo} onCLickInMindUpMobileAdmin={processCheckBarClick} $barType='mobileButton' hover='none' />
            </ProcessCheckBarWrapper>
        </Layout>
    );
};
export const Reschedule = ({ diagnosisInfo, processCheckBarClick }: CounselingCardsProps) => {
    const navigate = useNavigate();

    const { birthDate } = calculateAge(diagnosisInfo?.patientIdentityNumber || '');

    return (
        <Layout onClick={() => navigate(mindupAdminMobilePaths.mindUpAdminMobileDetailDiagnosis, { state: diagnosisInfo })}>
            <TitleWrapper $color={TextColor.color_text_normal} $backgroundColor={BackgroundColor.color_background_neutral} style={{ justifyContent: 'space-between' }}>
                <NoShowWrapper>
                    <IcCalendarRed />
                    노쇼로 일시 변경이 필요합니다.
                </NoShowWrapper>
                <ArrowWrapper>
                    <IcArrowRightSlim />
                </ArrowWrapper>
            </TitleWrapper>
            <InfoContainer>
                <FlexWrapper>
                    <InfoTitle>대상자</InfoTitle>
                    <Name>{diagnosisInfo?.patientName}</Name>
                    {diagnosisInfo?.patientGender === 'male' ? <GenderMan $width='16px' $height='16px' /> : <GenderWoman $height='16px' $width='16px' />}
                    <BirthWrapper>({birthDate})</BirthWrapper>
                </FlexWrapper>
                <FlexWrapper>
                    <InfoTitle>연락처</InfoTitle>
                    <Body3Regular>{changeMobileForm(diagnosisInfo?.patientMobile!)}</Body3Regular>
                </FlexWrapper>
            </InfoContainer>
            <ProcessCheckBarWrapper>
                <ProcessCheckBar diagnosisInfo={diagnosisInfo} onCLickInMindUpMobileAdmin={processCheckBarClick} $barType='mobileButton' />
            </ProcessCheckBarWrapper>
        </Layout>
    );
};
export const Request = ({ diagnosisInfo, onClick }: CounselingCardsProps) => {
    const navigate = useNavigate();

    const { birthDate } = calculateAge(diagnosisInfo?.patientIdentityNumber || '');

    return (
        // <Layout onClick={() => navigate(mindupAdminMobilePaths.mindUpAdminMobileDetailDiagnosis, { state: diagnosisInfo })}>
        <Layout>
            <TitleWrapper $color={TextColor.color_text_normal} $backgroundColor={BackgroundColor.color_background_primary_neutral}>
                <IcCalendarPointColorBlue />
                예약 대기 상담
            </TitleWrapper>
            <InfoContainer>
                <FlexWrapper>
                    <InfoTitle>대상자</InfoTitle>
                    <Name>{diagnosisInfo?.patientName}</Name>
                    {diagnosisInfo?.patientGender === 'male' ? <GenderMan $width='16px' $height='16px' /> : <GenderWoman $height='16px' $width='16px' />}
                    <BirthWrapper>({birthDate})</BirthWrapper>
                </FlexWrapper>
                <FlexWrapper>
                    <InfoTitle>연락처</InfoTitle>
                    <Body3Regular>{changeMobileForm(diagnosisInfo?.patientMobile!)}</Body3Regular>
                </FlexWrapper>
            </InfoContainer>
            <SelectDateContainer>
                {diagnosisInfo?.counselDateTimeList.map((item, idx) => (
                    <SelectDateWrapper key={idx} onClick={() => onClick!({ diagnosisId: diagnosisInfo?._id, reservationDate: item })}>
                        <Date>{splitDateTime(item).date}</Date>
                        <Time>{splitDateTime(item).time}</Time>
                    </SelectDateWrapper>
                ))}
            </SelectDateContainer>
        </Layout>
    );
};

export const Complete = ({ diagnosisInfo, processCheckBarClick }: CounselingCardsProps) => {
    const navigate = useNavigate();

    const { birthDate } = calculateAge(diagnosisInfo?.patientIdentityNumber || '');

    return (
        <Layout onClick={() => navigate(mindupAdminMobilePaths.mindUpAdminMobileDetailDiagnosis, { state: diagnosisInfo })}>
            <TitleWrapper $color={TextColor.color_text_normal} $backgroundColor={Accent['color_accent-purple-opacity-4']} style={{ justifyContent: 'space-between' }}>
                <DateWrapper>
                    <IcCalendarPointColorPurple />
                    {formatDateTime(diagnosisInfo?.diagnosisDateTime!)}
                    <Body3Medium style={{ color: TextColor.color_text_light, marginLeft: '-4px' }}>상담</Body3Medium>
                </DateWrapper>
                <ArrowWrapper>
                    <IcArrowRightSlim />
                </ArrowWrapper>
            </TitleWrapper>
            <InfoContainer>
                <FlexWrapper>
                    <InfoTitle>대상자</InfoTitle>
                    <Name>{diagnosisInfo?.patientName}</Name>
                    {diagnosisInfo?.patientGender === 'male' ? <GenderMan $width='16px' $height='16px' /> : <GenderWoman $height='16px' $width='16px' />}
                    <BirthWrapper>({birthDate})</BirthWrapper>
                </FlexWrapper>
                <FlexWrapper>
                    <InfoTitle>연락처</InfoTitle>
                    <Body3Regular>{changeMobileForm(diagnosisInfo?.patientMobile!)}</Body3Regular>
                </FlexWrapper>
            </InfoContainer>
            <ProcessCheckBarSmallWrapper>
                <ProcessCheckBar diagnosisInfo={diagnosisInfo} onCLickInMindUpMobileAdmin={processCheckBarClick} $type='mindupAdminMobile' $height='32px' hover='none' />
            </ProcessCheckBarSmallWrapper>
        </Layout>
    );
};

export const NoShowTerminate = ({ diagnosisInfo }: CounselingCardsProps) => {
    const navigate = useNavigate();

    const { birthDate } = calculateAge(diagnosisInfo?.patientIdentityNumber || '');

    return (
        <Layout onClick={() => navigate(mindupAdminMobilePaths.mindUpAdminMobileDetailDiagnosis, { state: diagnosisInfo })}>
            <TitleWrapper $color={TextColor.color_text_normal} $backgroundColor={BackgroundColor.color_background_normal} style={{ justifyContent: 'space-between' }}>
                <DateWrapper>
                    <IcCalendarPointColorLightGray />
                    <NoShowDateWrapper>{formatDateTime(diagnosisInfo?.diagnosisDateTime!)}</NoShowDateWrapper>
                    <Body3Medium style={{ color: TextColor.color_text_light, marginLeft: '-4px' }}>상담</Body3Medium>
                </DateWrapper>
                <ArrowWrapper>
                    <IcArrowRightSlim />
                </ArrowWrapper>
            </TitleWrapper>
            <InfoContainer>
                <FlexWrapper>
                    <InfoTitle>대상자</InfoTitle>
                    <Name>{diagnosisInfo?.patientName}</Name>
                    {diagnosisInfo?.patientGender === 'male' ? <GenderMan $width='16px' $height='16px' /> : <GenderWoman $height='16px' $width='16px' />}
                    <BirthWrapper>({birthDate})</BirthWrapper>
                </FlexWrapper>
                <FlexWrapper>
                    <InfoTitle>연락처</InfoTitle>
                    <Body3Regular>{changeMobileForm(diagnosisInfo?.patientMobile!)}</Body3Regular>
                </FlexWrapper>
            </InfoContainer>
            <ProcessCheckBarSmallWrapper>
                <ProcessCheckBar diagnosisInfo={diagnosisInfo} $type='mindupAdminMobile' $height='32px' hover='none' />
            </ProcessCheckBarSmallWrapper>
        </Layout>
    );
};

const Layout = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid ${BorderColor.color_border_light};
    border-radius: ${Radius.radius_12};
    overflow: hidden;
    &:active {
        border-color: ${BorderColor.color_border_normal};
        box-shadow: 0px 0px 8px 0px rgba(16, 16, 16, 0.08);
    }
`;

const TitleWrapper = styled(Body3SemiBold)<{ $color?: string; $backgroundColor?: string }>`
    display: flex;
    gap: 6px;
    align-items: center;
    padding: 16px;
    color: ${({ $color }) => $color};
    background-color: ${({ $backgroundColor }) => $backgroundColor || 'transparent'};
`;

const DateWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const NoShowDateWrapper = styled(Body3SemiBold)`
    color: ${TextColor.color_text_weak};
    text-decoration: line-through;
    -webkit-text-decoration: line-through;
    text-decoration-line: line-through;
    text-decoration-style: solid;
`;

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 20px 20px 20px;
    width: 100%;
    gap: 6px;
`;

const InfoTitle = styled(Body5Regular)`
    width: 60px;
    color: ${TextColor.color_text_light};
`;

const BirthWrapper = styled(Body3Regular)`
    margin-left: 2px;
`;

const FlexWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Name = styled(Body4Medium)`
    margin-right: 1px;
`;

const ArrowWrapper = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ProcessCheckBarWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 16px 16px 16px;
`;

const ProcessCheckBarSmallWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 156px;
    // background-color: red;
    padding: 0 0 20px 20px;
`;

const SelectDateContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 6px;
    padding: 0 16px 16px 16px;
`;

const SelectDateWrapper = styled.button`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1px;
    padding: 12px 15px;
    min-width: 95px;
    width: clamp(95px, calc(95px + (100vw - 360px) * 0.3333), 167px);
    height: 65px;
    border: 1px solid ${BorderColor.color_border_neutral};
    border-radius: ${Radius.radius_8};
    &:active {
        border-color: ${BorderColor.color_border_normal_hover};
        // box-shadow: 0px 0px 8px 0px rgba(16, 16, 16, 0.08);
    }
`;

const Date = styled(Body5SemiBold)``;

const Time = styled(Body5Regular)``;

const NoShowWrapper = styled(Body3SemiBold)`
    display: flex;
    align-items: center;
    gap: 6px;
    color: ${TextColor.color_text_weak};
`;
